<template>
	<v-dialog v-model="show" class="d-none" width="500">
		<template v-slot:activator="{ on }">
			<v-btn
				dark
				flat
				v-bind="btnProps"
				v-on="on"
			>
				<v-spacer />
				Forms
			</v-btn>
		</template>

		<v-card>
			<v-card-title class="headline grey lighten-3">
				Forms
				<v-spacer />
				<v-btn flat icon @click="show = false">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>

			<v-card-text>
				<v-btn
					v-for="(fileName) in formFileNames"
					:key="fileName[0]"
					v-external
					:href="'/res/forms/allstarkidsacademy-' + fileName[0] + '.pdf'"
					class="my-3"
					block
					flat
					small
				>
					<img v-wh="32" src="/img/logo-pdf.png" class="mr-4">
					{{ fileName[1] }}
					<v-spacer />
				</v-btn>
			</v-card-text>

			<v-card-actions>
				<v-spacer />

				<v-btn color="blue" dark href="/res/forms/allstarkidsacademy-forms.zip">
					Download All Forms As .zip File
					<img v-wh="28" src="/img/logo-zip.png" class="ml-4">
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		btnProps: {
			type: Object,
			default: null,
		},
	},

	data: () => ({
		show: false,
		formFileNames: [
			[ 'enrollment-form',           'Enrollment Form' ],
			[ 'parent-agreement',          'Parent Agreement' ],
			[ 'bus-auth',                  'Bus Authorization' ],
			[ 'info-to-parents',           'Info to Parents' ],
			[ 'info-to-parents-signature', 'Info to Parents - Signature' ],
			[ 'tuition-policy',            'Tuition Policy' ],
			[ 'recurring-payment-auth',    'Recurring Payment Authorization' ],
		],
	}),
}
</script>
